Ext.define('SA.lq.view.View', {
    alias: 'widget.lq-view',
    extend: 'SA.view.SimpleContainer',

    cls: 'sa-lq-view',

    initComponent() {
        this.items = [
            {
                xtype: 'simple-container',
                cls: 'sa-lq-view-panels',
                itemId: 'panelsCmp',

                items: [
                    this.attributesPanel,
                    {
                        xtype: 'lq-conditions-panel',
                        itemId: 'conditionsPanel'
                    }
                ]
            }, {
                xtype: 'simple-container',
                cls: 'sa-lq-view-results-panel',
                hidden: true,
                itemId: 'resultsPanel',

                items: [
                    {
                        xtype: 'lq-results-panel-header',
                        html: '&nbsp;', 
                        itemId: 'resultsHeader'
                    }, {
                        xtype: 'simple-container',
                        cls: 'sa-lq-view-results-panel-body',

                        items: [
                            {
                                xtype: 'report-grid',
                                hidden: true,
                                itemId: 'resultsGrid'
                            }
                        ]
                    }
                ]
            }
        ];

        this.callParent();
    }
});